import { CameraData } from 'src/models/CameraData.model';

import { convertToByte } from 'src/utils/parseStorage';

import { APP_EVENTS, captureAppEvent } from './posthogEvents';

const LOW_BATTERY_THRESHOLD_PCT = 20;
const HIGH_STORAGE_USAGE_THRESHOLD_PCT = 90;

let prevBatteryPct: number | undefined;
let prevStoragePct: number | undefined;

export function resetCameraThresholdState(): void {
  prevBatteryPct = undefined;
  prevStoragePct = undefined;
}

function emitBatteryLowIfCrossed(currentCameraData: CameraData): void {
  const battCap = currentCameraData.batteryInfo?.battCap;
  if (battCap === undefined) return;

  const wasBelow =
    prevBatteryPct !== undefined && prevBatteryPct < LOW_BATTERY_THRESHOLD_PCT;
  prevBatteryPct = battCap;

  if (battCap >= LOW_BATTERY_THRESHOLD_PCT) return;
  if (wasBelow) return;

  captureAppEvent(APP_EVENTS.CAMERA_BATTERY_LOW, { battery_pct: battCap });
}

function emitStorageHighIfCrossed(currentCameraData: CameraData): void {
  const usage = currentCameraData.storage?.usage;
  if (!usage) return;

  const [usedStr, totalStr] = usage.split('/');
  const used_bytes = convertToByte(usedStr);
  const total_bytes = convertToByte(totalStr);
  if (!used_bytes || !total_bytes) return;

  const storage_pct = Math.round((used_bytes / total_bytes) * 100);
  const wasAbove =
    prevStoragePct !== undefined &&
    prevStoragePct > HIGH_STORAGE_USAGE_THRESHOLD_PCT;
  prevStoragePct = storage_pct;

  if (storage_pct <= HIGH_STORAGE_USAGE_THRESHOLD_PCT) return;
  if (wasAbove) return;

  captureAppEvent(APP_EVENTS.CAMERA_STORAGE_LOW, {
    storage_pct,
    used_bytes,
    total_bytes,
  });
}

export function emitCameraThresholdEvents(currentCameraData: CameraData): void {
  emitBatteryLowIfCrossed(currentCameraData);
  emitStorageHighIfCrossed(currentCameraData);
}
